export default {"src":"https://images-cdn.curipod.com/d-20cf10f3/_next/static/media/common_sense_media.9c180185.svg","height":123,"width":300};